import type { ListDevicesQuery } from '../../__generated__/graphql/api';

import { distinctProgramNames } from '../../utils/distinctProgramNames';

type ListDevicesResultDevices = NonNullable<NonNullable<ListDevicesQuery['listDevices']>['devices']>;

type ListDevicesResultDevice = NonNullable<ListDevicesResultDevices[number]>;

export interface DeviceListItem {
  id: string;
  userId: string | null;
  deviceType: string | null;
  deviceModel: string | null;
  osVersion: string | null;
  appVersion: string | null;
  lastUsedAt: string | null;
  createdAt: string | null;
  isActive: boolean;
  programNames: string[];
}

export const toDeviceListItem = (device: ListDevicesResultDevice): DeviceListItem => ({
  id: device.id ?? '',
  userId: device.userId ?? null,
  deviceType: device.deviceType ?? null,
  deviceModel: device.deviceModel ?? null,
  osVersion: device.osVersion ?? null,
  appVersion: device.appVersion ?? null,
  lastUsedAt: device.lastUsedAt ?? null,
  createdAt: device.createdAt ?? null,
  isActive: !device.deletedAt,
  programNames: distinctProgramNames(device.user?.loans ?? []),
});
